<template>
  <span :title="title" class="title">{{document.identificador}}</span>
</template>
<script>
  import map from 'lodash/map'

  export default {
    props: ['document', 'text', 'elements', 'matches'],
    computed: {
      title() {
        const fields = this.$ncsCsvElementFields(this.document, this.text, this.elements, this.matches)
        return map(fields, (v, k) => `${k}: ${v || ''}`).join('\n')
      }
    }
  }
</script>
